var Price = /*@__PURE__*/ (function () {
    function Price(data) {
        if (data.label) {
            this.label = data.label;
        }
        if (data.value) {
            this.type = data.value.indexOf('%') > -1 ? 'percentage' : 'fixed';
            this.value = parseFloat(data.value.replace(/,/, '.'));
        }
        if (data.recurrenceInterval) {
            this.recurrenceInterval = data.recurrenceInterval;
        }
        if (data.recurrenceUnit) {
            this.recurrenceUnit = data.recurrenceUnit;
        }
        if (data.recurrenceStart) {
            this.recurrenceStart = parseInt(data.recurrenceStart, 10);
        }
        if (data.recurrenceEnd) {
            this.recurrenceEnd = parseInt(data.recurrenceEnd, 10);
        }
        if (data.strikePrice) {
            this.strikePrice = parseFloat(data.strikePrice.replace(/,/, '.'));
        }
    }
    return Price;
}());
export { Price };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/price.ts
// module id = null
// module chunks = 